import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import HeroCarousel from "../components/HeroCarousel";
import BrandShowcase from "../components/BrandShowcase";
import ProductSection from "../components/ProductSection";
import ServicesSection from "../components/ServicesSection";
import BrandsGrid from "../components/BrandsGrid";
import TrendingNow from "../components/TrendingNow";
import Testimonials from "../components/Testimonials";
import { useLocale } from "../contexts/LocaleContext";

export default function Home() {
  const { t } = useLocale();
  const [all, setAll] = useState([]);
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products?limit=60").then(r => setAll(r.data.items || []));
    api.get("/products?featured=true&limit=12").then(r => setFeatured(r.data.items || []));
  }, []);

  const luxury = all.filter(p => p.sections?.includes("vintage_luxury") || ["luxury", "dress", "chronograph"].includes(p.category)).slice(0, 6);
  const sport = all.filter(p => p.sections?.includes("sport_chronograph") || ["sport", "diving", "chronograph"].includes(p.category)).slice(0, 6);
  const newArrivals = all.filter(p => p.sections?.includes("new_arrivals") || p.is_new).slice(0, 6);
  const onSale = all.filter(p => p.sections?.includes("on_sale") || (p.original_price && p.original_price > p.price)).slice(0, 6);

  return (
    <>
      <HeroCarousel />

      <section className="bg-white">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-10 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { t: "Authenticated", d: "Master horologists verify every piece" },
            { t: "Worldwide Insured Shipping", d: "Complimentary above AED 5,000" },
            { t: "2-Year Warranty", d: "Full manufacturer warranty included" },
            { t: "Concierge Service", d: "Available 24/7 via chat & WhatsApp" },
          ].map((it, i) => (
            <div key={i} className="border-l-2 border-copper pl-4">
              <div className="text-sm text-dark tracking-wide font-display">{it.t}</div>
              <div className="text-xs text-gray-500 mt-1">{it.d}</div>
            </div>
          ))}
        </div>
      </section>

      <BrandShowcase />

      {/* Premier Destination */}
      <section className="bg-[#FAF7F2] border-y border-black/5">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-24 grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="overline mb-4">Premier Destination</div>
            <h2 className="font-display text-4xl md:text-5xl text-dark tracking-tight leading-[1.05]">For <em className="text-copper not-italic">Pre-Owned Luxury Watches</em> & Accessories in Dubai, UAE.</h2>
            <p className="text-gray-600 mt-6 leading-relaxed">Experience the ultimate destination for luxury. Luxe Watches curates an unparalleled collection of pre-owned and brand-new watches, designer leather handbags, and elite accessories. Discover world-class premium brands, refined for the most discerning eyes in Dubai.</p>
            <Link to="/shop" className="btn-primary mt-10">Explore Our Collection</Link>
          </div>
          <div className="aspect-[4/3] overflow-hidden">
            <img src="https://images.pexels.com/photos/15019857/pexels-photo-15019857.jpeg?auto=compress&cs=tinysrgb&w=1400" alt="" className="w-full h-full object-cover"/>
          </div>
        </div>
      </section>

      <ProductSection id="vintage" overline="The Collection" title="Vintage & Luxury Watches" items={featured.length ? featured : luxury}/>
      <ProductSection id="sport" overline="The Collection" title="Sport & Chronograph" items={sport} viewAll="/shop?category=sport"/>
      <ProductSection id="new" overline="The Latest Pieces" title="New Arrivals" items={newArrivals.length ? newArrivals : all.slice(0,6)}/>
      {onSale.length > 0 && <ProductSection id="sale" overline="Limited Offers" title="On Sale" items={onSale}/>}

      <ServicesSection />
      <BrandsGrid />
      <TrendingNow items={all}/>
      <Testimonials />
    </>
  );
}
